// Info Button Component
// Reusable component to display contextual help information

import React from "react";
import { Button, Tooltip } from "@fluentui/react-components";
import { InfoRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import "./CSS/InfoButton.css";

const InfoButton = ({ infoKey, category }) => {
  const { t } = useTranslation();

  // Get the info text from translations
  const translationKey = `INFO.${category}.${infoKey}`;
  const infoText = t(translationKey, { defaultValue: "" });

  if (!infoText) return null;

  return (
    <Tooltip
      content={infoText}
      relationship="description"
      className="info-tooltip"
    >
      <Button
        icon={<InfoRegular className="info-icon" />}
        appearance="transparent"
        iconOnly
        size="small"

      />



    </Tooltip>
  );
};

InfoButton.propTypes = {
  infoKey: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired
};

export default InfoButton;
